import { render, staticRenderFns } from "./user_dataset_statistics_query_products.vue?vue&type=template&id=1711346f"
import script from "./user_dataset_statistics_query_products.vue?vue&type=script&lang=js"
export * from "./user_dataset_statistics_query_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports